import React from 'react'

import Section from '@components/Section/Section'

import * as styles from './SliderSection.module.scss'

interface Props {
	title: React.ReactNode
	button?: React.ReactNode
	slider: React.ReactNode
	className?: string
	sectionClassName?: string
}

const SliderSection = (props: Props) => {
	const sliderStyles = [styles.slider]
	const sectionStyles = [styles.section]

	if (props.className) {
		sliderStyles.push(props.className)
	}

	if (props.button) {
		sliderStyles.push(styles.hasButton)
	} else {
		sectionStyles.push(styles.noButton)
	}

	if (props.sectionClassName) {
		sectionStyles.push(props.sectionClassName)
	}

	const title = React.cloneElement(props.title as React.ReactElement, { className: styles.title })

	return (
		<Section className={sectionStyles.join(' ')}>
			{title}
			{props.button}
			<div className={sliderStyles.join(' ')}>{props.slider}</div>
		</Section>
	)
}

export default SliderSection
